import React from 'react';
import { dateDiff } from 'common/utils/date';
import { FormattedMessage, intlShape } from 'react-intl';

class Countdown extends React.Component {
    componentWillMount() {
        this.addFormatJsCompatibleCountDownMessage();
    }

    addFormatJsCompatibleCountDownMessage() {
        const { formatMessage } = this.context.intl;
        const t = (messageId) => formatMessage({id: messageId});

        let days = `{days, plural, =1 {${t('countdown.message_day')}} other {# ${t('countdown.message_days')}}}`;
        let hours = `{hours, plural, =1 {${t('countdown.message_hour')}} other {# ${t('countdown.message_hours')}}}`;
        let minutes = `{minutes, plural, =1 {${t('countdown.message_minute')}} other {# ${t('countdown.message_minutes')}}}`;

        this.context.intl.messages['countdown.message_expire'] = `${t('countdown.message_expire')} ${days}, ${hours}, ${minutes}`;
    }

    componentDidMount() {
        setInterval(() => {
            this.forceUpdate();
        }, 5000);
    }

    render() {
        const diff = dateDiff(new Date(), new Date(this.props.endDate));
        const completeMessage = <FormattedMessage id='countdown.message_complete' />;
        const defaultMessage = (
            <FormattedMessage
                id='countdown.message_expire'
                values={{
                    days: diff.days,
                    hours: diff.hours,
                    minutes: diff.minutes,
                }}
            />
        );

        return diff.diff > 0 ? defaultMessage : completeMessage;
    }
}

Countdown.propTypes = {
    endDate: React.PropTypes.string.isRequired
};

Countdown.contextTypes = {
    intl: intlShape.isRequired
};

export default Countdown;



/** WEBPACK FOOTER **
 ** ./js/marketing/components/countdown.jsx
 **/